<div class="questionnaire-field-spacer d-flex flex-column">
    <p-select
            [formControl]="formControl"
            [optionValue]="props.optionValue"
            [placeholder]="props.placeholderText | translate"
            [optionLabel]="props.optionLabel"
            [filter]="props.canFilter"
            [showClear]="props.canClear"
            [options]="props.selectOptions"
    ></p-select>
    <formly-validation-message [field]="field" *ngIf="formControl?.invalid &&
  formControl?.dirty" />
</div>
